export default async (cb = null) => {
  if (typeof window === 'undefined') return
  if (window.caches) {
    const cacheNames = await window.caches?.keys()
    for (let name of cacheNames) {
      const caching = await caches.open(name)
      const keys = await caching.keys()
      for (let key of keys) {
        await caching.delete(key)
      }
      await window.caches.delete(name)
    }
  }
  if (window.navigator?.serviceWorker?.getRegistration) {
    const registration = await window.navigator.serviceWorker.getRegistration()
    if (registration?.waiting?.postMessage) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    }
    if (registration?.active?.postMessage) {
      registration.active.postMessage({ type: 'SKIP_WAITING' })
    }
  }
  if (window.navigator?.serviceWorker?.getRegistrations) {
    window.navigator.serviceWorker.getRegistrations().then(registrations => {
      for (let registration of registrations) {
        registration.unregister()
      }
    })
  }
  if (typeof cb === 'function') {
    cb()
  }
}
